import { render, staticRenderFns } from "./ShapeIcon.vue?vue&type=template&id=75900e94&scoped=true&"
import script from "./ShapeIcon.vue?vue&type=script&lang=js&"
export * from "./ShapeIcon.vue?vue&type=script&lang=js&"
import style0 from "./ShapeIcon.vue?vue&type=style&index=0&id=75900e94&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75900e94",
  null
  
)

export default component.exports